import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ssnpnu4tp4: FaireBrandEntity = {
  token: "b_ssnpnu4tp4",
  type: "brand",
  name: "Supreme Fashion",
  avatarUrl:
    "https://cdn.faire.com/fastly/371fbb850edc1a6bd83344d1b4ac6d94157d0482146b06b110c2b81d8253b6f6.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f8f746baee84d7bf04fabf0357dade2431c6a768d94c0c728b3ccdeb6ab35e1c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/371fbb850edc1a6bd83344d1b4ac6d94157d0482146b06b110c2b81d8253b6f6.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f8f746baee84d7bf04fabf0357dade2431c6a768d94c0c728b3ccdeb6ab35e1c.jpeg",
  location: "ontario, CA, USA",
  minimumOrderDollars: 152,
  rating: 4.2,
  reviewCount: 731,
  isInsider: true,
  description:
    "Born and raised in Los Angeles, Supreme fashion is a California lifestyle collection for women. Over the years, Supreme fashion has evolved into a prominent fashion house offering seasonal favorites and wardrobe staples that reflect our commitment to cutting edge design and attention to every last detail. Our women’s collection is made up of denim that takes you from morning to moonlight, feminine blouses, effortlessly chic dresses and everything in between. Our women’s collections is the perfect mix of pieces that you can live in and will keep forever. We are dedicated to the details and won’t stop until we achieve the perfect fit. Each item is meticulously designed, washed and wear-tested to ensure that it’s not only of the moment but built for the moment. Our target are always grow, reinvent yourself and evolve for the better. We take this approach to design and beyond.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:55.944Z",
    importedBy: "entity-db-cli",
  },
};
